import { darken, IconButton, IconButtonProps } from '@mui/material';
import { forwardRef } from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  variant?: 'primary' | 'regular' | 'success' | 'warning' | 'error';
}

const PaiIconButton = forwardRef<HTMLButtonElement, IconButtonProps & Props>(({ variant = 'regular', ...props }, ref) => {
  const { classes } = useStyles({ variant });

  return (
    <IconButton className={classes.paiIconButton} ref={ref} {...props}>
      {props.children}
    </IconButton>
  );
});

const useStyles = makeStyles<{ variant?: 'primary' | 'regular' | 'success' | 'warning' | 'error' }>()((theme, { variant }) => ({
  paiIconButton: {
    background:
      variant === 'success'
        ? theme.palette.backgrounds.success
        : variant === 'warning'
        ? theme.palette.backgrounds.warning
        : variant === 'error'
        ? theme.palette.backgrounds.error
        : variant === 'primary'
        ? theme.palette.primary.main
        : variant === 'regular'
        ? 'linear-gradient(to bottom, #5044FF, #4AA4FF)'
        : '#FFF',
    '& svg': {
      color: variant === 'regular' || variant === 'primary' ? '#FFF' : theme.palette.text.primary,
    },
    '&:hover': {
      background:
        variant === 'success'
          ? darken(theme.palette.backgrounds.success, 0.05)
          : variant === 'warning'
          ? darken(theme.palette.backgrounds.warning, 0.05)
          : variant === 'error'
          ? darken(theme.palette.backgrounds.error, 0.05)
          : variant === 'primary'
          ? theme.palette.secondary.main
          : variant === 'regular'
          ? 'linear-gradient(to bottom, #4AA4FF, #5044FF)'
          : '#FFF',
    },
    '&.Mui-disabled': {
      color: theme.palette.action.disabled,
      background: theme.palette.action.disabledBackground,
    },
    '&.MuiIconButton-sizeSmall': {
      padding: '6px',
      '& svg': {
        fontSize: theme.typography.pxToRem(16),
      },
    },
  },
}));

PaiIconButton.displayName = 'PaiIconButton';

export default PaiIconButton;
